import clearIsDirty from '../../actions/clearIsDirty';
import { EventsAndInvitesViewState } from 'mini-options-store/lib/store/schema/EventsAndInvitesViewState';
import { getOptionsStore } from '../../store/Store';
import { hideFullScreenSpinner, showFullScreenSpinner } from 'mini-full-screen-spinner';
import { lazySaveCalendarCloudSettings } from 'mini-calendar-cloud-settings';
import { logDatapointsOnSaveEventsAndInvitesOption } from '../../utils/eventsAndInvites/logDatapointsOnSaveEventsAndInvitesOption';
import { orchestrator } from 'satcheljs';
import { saveEventsAndInvitesOption } from '../../actions/eventsAndInvites/saveEventsAndInvitesOption';

export const saveEventsAndInvitesOptionOrchestrator = orchestrator(
    saveEventsAndInvitesOption,
    async () => {
        const optionsStore = getOptionsStore();
        if (optionsStore?.activeViewState && optionsStore?.activeViewState?.isDirty) {
            const viewState = optionsStore.activeViewState as EventsAndInvitesViewState;
            const {
                enableOnlineMeetingsByDefault,
                shouldEventsEndEarly,
                endShortEventsBy,
                endLongEventsBy,
            } = viewState;
            const calendarCloudSettings = {
                enableOnlineMeetingsByDefault,
                shouldEventsEndEarly,
                endShortEventsBy,
                endLongEventsBy,
            };

            // start the spinner
            showFullScreenSpinner();

            // log datapoints
            logDatapointsOnSaveEventsAndInvitesOption(viewState);

            // perform the update
            await lazySaveCalendarCloudSettings.importAndExecute(calendarCloudSettings);

            // Clear the isDirty flag
            clearIsDirty();

            // remove the spinner
            hideFullScreenSpinner();
        }
    }
);
